/*eslint-disable @typescript-eslint/no-duplicate-enum-values*/

export namespace FieldLength {
  export enum MaxFieldLength {
    //maxGroupNameLength = 100,
    maxGroupNameLength = 250,
    maxGroupDescriptionLength = 250,
    topicAttributeMaxStringLength = 400,
    maxInboxLength = 50,
    maxDisplayNameLength = 50,
  }

  export enum User {
    maxUserNameLength = 250,
    minUserNameLength = 6,
    maxPhoneNoLength = 50,
    maxMobileNoLength = 50,
    maxAddressLength = 250,
    maxCityLength = 128,
    maxStateLength = 128,
    maxZipCodeLength = 40,
    maxCountryLength = 250,
    maxFirstNameLength = 50,
    maxMiddleNameLength = 50,
    maxLastNameLength = 50,
    maxTitleLength = 100,
    maxPrefixLength = 50,
    maxSuffixLength = 50,
  }

  export enum WCF {
    maxRequestLength = 1024 * 1024, // bytes
  }

  export enum QMS {
    maxProductNameLength = 128,
  }
}
